
import { Component, Vue, Prop, Emit } from "vue-property-decorator";
import Slick from "vue-slick";
import LazyImage from "./../LazyImage.vue";
import { CommunityQmiDetails, HomesPlan, LotDetail, LotInfo } from "./../../types";
import { Status, Scalers, LinkOpenConatactInfo } from "./../../constant";
import { apiMessages } from "../../api/message-api";
import { addImageScaler, convertToTitleCase, formatPrice } from "@/core";
import Location from "@/assets/icons/Location.vue";
import { isIE } from "mobile-device-detect";

@Component({
  components: {
    Slick,
    LazyImage,
    Location
  },
})
export default class PlatMapModal extends Vue {
  $refs!: any;
  sliderOptions: any = {
    slidesToShow: 1,
    infinite: false,
  };
  private availableStatus = Status;
  private errorMessage = "Information for this lot is not yet available";
  private messages: any = {};
  private loading = isIE;
  private trailingText = [] as Array<string>
  private linkOpenConatactInfo = LinkOpenConatactInfo;
  private showDefaultImage = false;
  @Prop() private lotId!: string;
  @Prop() private lotInfo!: LotInfo;
  @Prop() private isKioskMode!: boolean;
  @Prop() private neighborhoodId!: string;
  @Prop(Function) updateLotInfo!: (lotInfo: LotInfo|LotDetail, lotId: string) => void;
  @Prop(Function) mobileOpenContactInfo!: () => void;
  @Emit("openModal") openModal(modalName: string) {}

  constructor() {
    super();
    this.loadMessages();
  }

  mounted(){
    this.updateLotInfo(this.lotInfo, this.lotId);
  }
  async loadMessages() {
    const { messages } = await apiMessages("PlatMapModal");
    this.messages = messages;
    this.trailingText = this.messages.soldHomesMessage.split(this.linkOpenConatactInfo);
  }

  handleReInit() {
    this.$nextTick(() => {
      this.$refs.slick.reSlick();
    });
  }
 
  checkLowRange(property1: string, property2:string, homePlan: HomesPlan){
    return (
           ![this.availableStatus.AVAILABLE, this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status) &&
            homePlan[property1] != null && homePlan[property1] ) ||
            [this.availableStatus.AVAILABLE, this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status) &&
            homePlan[property1] != homePlan[property2] && homePlan[property1];
  }

  handleSiteReInit() {
    this.$nextTick(() => {
      this.$refs.siteSlick.reSlick();
    });
  }

  get showHomePlanLabel() {
    return this.lotInfo.homes_plans.length && [this.availableStatus.AVAILABLE,this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status);
  }
  
  get showFutureHomePlanLabel() {
    return this.lotInfo.homes_plans.length && [this.availableStatus.FUTURE_HOME].includes(this.lotInfo.lot.status);
  }

  get showSoldMessage() {
    return (
      [this.availableStatus.SOLD, this.availableStatus.FUTURE_HOME].includes(
        this.lotInfo.lot.status
      ) || this.isKioskMode
    );
  }

  convertToTitleCase(value: string) {
    return convertToTitleCase(value);
  }
  
  formatPrice(value) {
    return formatPrice(value);
  }

  formatSquareFeet(x) {
    return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }

  formatDate(moveInDate: string) {
    let date = new Date(moveInDate);
    let formattedDate = date.toDateString().split(" ");
    return `${formattedDate[1]} ${formattedDate[2]}, ${formattedDate[3]}`;
  }

  get lotStatus() {
    let status = this.lotInfo.lot.status;
    if ([this.availableStatus.QUICK_MOVE_IN].includes(status)) status = "qmi";
    else if (
      [this.availableStatus.SOLD, this.availableStatus.AVAILABLE].includes(
        status
      )
    )
      status = status.toLowerCase();
    return status;
  }
  isRange(val_low, val_high) {
    return val_low != null && val_low != val_high && val_high && val_low;
  }
  suppressScheduleVisit() {
    return (
      [this.availableStatus.SOLD, this.availableStatus.RESERVED,this.availableStatus.FUTURE_HOME].includes(
        this.lotInfo.lot.status
      ) || this.isKioskMode
    );
  }

  openPlanDetails(planURL: Location) {
    window.open(`${planURL}`, `HomePlans_WindowName`);
  }

  openKioskPlanView(planCode: number) {
    let kioskPlanLink = `${process.env.VUE_APP_KIOSK_URL}planView?`;
    if (this.lotStatus === this.availableStatus.AVAILABLE.toLowerCase()) {
      kioskPlanLink += `plan_code=${planCode}&neighborhood_code=${this.neighborhoodId}`;
    } else if (this.lotStatus === 'qmi') {
      kioskPlanLink += `job_number=${this.lotInfo.lot.id}&neighborhood_code=${this.neighborhoodId}`;
    }
    window.open(`${kioskPlanLink}`, `HomePlans_WindowName`);
  }

  checkRangeAndFutureHome(homePlan: HomesPlan){
    return this.isRange(homePlan.price_low, homePlan.price_high) && this.lotInfo.lot.status !== this.availableStatus.FUTURE_HOME
  }
  imageSource(src) {
    if (typeof src == "object" && src.image_url){
      return this.addScaler(src.image_url);
    }else {
      this.showDefaultImage = true;
      return require("@/assets/images/home-not-available.png");
    }
  }

  addScaler(url) {
    return addImageScaler(url);
  }
}
